/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component, PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Contact.css';
import Helmet from 'react-helmet';
import fetch from '../../core/fetch';
import ContactForm from '../../components/ContactForm';
import Loader from '../../components/Loader';

const title = 'Contact';

@withStyles(s)
export default class Contact extends Component {
    
	constructor(props) {
        super(props);

        this.state = {
            contact: [],
            loader: true,
        };

        
    }

    componentDidMount(){
        this.GetContact();
    }

    async GetContact(){

        const resp = await fetch('/graphql', {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: '{contact{id, slug, title, content}}',
            }),
            credentials: 'include',
        });
        const { data } = await resp.json();
        if (!data || !data.contact) throw new Error('Erreur sur le chargement de la page contact !');

        if(data){
            this.setState({ loader: false })
        }
        
        this.setState({ contact: data.contact })
    }

    render(){
        const appear = this.state.loader ? 'appear' : '';
        var background = {
            backgroundColor: '#00bf43'
        }

	    return (
            <div className={s.root}>
                <Helmet title={title} meta={[{"name": "description", "content": "Agence Web, Contact, Site Web, Marketing Web, Agence Prolifik"}]}/>
                <div className={`spinner ${appear}`} style={background} ></div>
	            <div id="contact" className={`contact`}>
                    <div className={`bgHeader`}></div>
                    <main role="main">
                        <div className={`wrapContact`}>
                            <div className={`col-sm-7 infoContact no-padding`}>
                                <div dangerouslySetInnerHTML={{ __html: this.state.contact.content }} />
                            </div>
                            <div className={`col-sm-5 formContact no-padding`}>
                                <div className={`wrapFormContact`}>
                                    <div className={`content`}>
                                        <span className={`titreFormContact`}>Planifier votre consultation gratuite</span>
                                        <span className={`texteFormContact`}>Planifiez un appel de consultation gratuit<br /> avec l’un de nos experts en stratégie web.</span>
                                        <div className={`wrapForm`}>
                                            <ContactForm />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
	        </div>
	    );
    }
}





// WEBPACK FOOTER //
// ./containers/contact/Contact.js